/* eslint-disable */
import { upgrades } from "../staticData";
import { storage } from "../storage";
export default class Alien {
    // class UpgradesManager {
    // amount: number;
    // price: number;
    // baseEarn: number;
    // locX: number;
    // locY: number;
    // skinName: string;

    constructor(alien) {
        this.amount = 0;
        this.id = alien.id;
        this.price = alien.price;
        this.baseEarn = alien.baseEarn;
        this.name = alien.name;
        this.imgSrc = alien.imgSrc;
        this.minGalaxyInd = alien.minGalaxyInd;
        this.isBoostable = upgrades.alienBoost.aliens.includes(alien.id)
        //   this.galaxyInd = alien.caveLvl && alien.caveLvl;
        // this.achievements = alien.achievements && alien.achievements;
        // this.zIndex = alien.zIndex;
        //   this.status = null;
        //   this.type = alien.type;
    }

    amountEarning(lvl = this.amount) {
        const boost = this.isBoostable ? upgrades.alienBoost.values[storage.UPGRADES_LVLS.alienBoost[this.id]] : 1
        return lvl === 0 ? BigInt(0) : BigInt((Math.floor(lvl * (lvl / 3)) * this.baseEarn + this.baseEarn) * boost);
    }
    upgradeCost(amount = 1) {
        let thePrice = 0
        const discount = upgrades.aliensDiscount.values[storage.UPGRADES_LVLS.aliensDiscount]
        for (let num = 1; num <= amount; num++) {
            if (this.amount === 0 && num === 1)
                thePrice += this.price;
            else if (this.amount <= 1 && num <= 2)
                thePrice += this.price * 2 * (100 - discount) / 100;
            else {
                thePrice += (this.amount + num) * this.price * (this.amount + num - 1) / 2;
                thePrice *= (100 - discount) / 100
                // if (amount > 1) console.log('ALIEN after', this.name, num, thePrice)
            }
        }
        return BigInt(Math.ceil(thePrice))
    }

}
